<template>
  <div
    :class="
      billStatus == '0'
        ? 'ccui-app-box-iframe-operate-container'
        : 'ccui-app-iframe-no-operate-container'
    "
  >
    <template v-if="labelShow">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <!--      <div class="detail-info-el-Label">-->
      <!--        <el-label :type="labelType" style="height: 100px;"></el-label>-->
      <!--      </div>-->
    </template>
    <div
      :class="
        billStatus == '0'
          ? 'ccui-app-iframe-container-detail'
          : 'ccui-app-iframe-container-no-operate-detail'
      "
    >
      <div class="ccui-app-iframe-container-detail-body">
        <el-tabs class="el-tabs__customize" value="1">
          <el-tab-pane label="技术评分" name="1">
            <template v-if="subPackageFlag">
              <el-tabs class="customeTab" v-model="active">
                <el-tab-pane
                  v-for="(listItem, listIndex) in listData"
                  :key="listIndex"
                  :label="listItem.packName"
                  :name="listIndex + ''"
                >
                  <template v-if="labelType != 'ScoreComplete'">
                    <div class="customeTab-button-body">
                      <div class="fr customeTab-button">
                        <template v-if="listItem.hasScore">
                          <el-button
                            style="z-index: 1"
                            type="single-number"
                            plain
                            @click="addOrEditData(listItem, 1)"
                            >编辑</el-button
                          >
                        </template>
                        <template v-else>
                          <el-button
                            style="z-index: 1"
                            type="single-number"
                            plain
                            @click="addOrEditData(listItem, 0)"
                            >新增</el-button
                          >
                        </template>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </template>
                  <!--                  <br />-->
                  <el-table :data="listItem.list" border>
                    <template v-for="(item, index) in listItem.columns">
                      <el-table-column
                        :key="index"
                        :show-overflow-tooltip="true"
                        v-bind="item"
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <el-table-column
                          v-for="(child, indexch) in item.labelChild"
                          :key="indexch"
                          :show-overflow-tooltip="true"
                          align="center"
                          v-bind="child"
                        >
                          <template slot="header">
                            <div class="el-tooltip">{{ child.label }}</div>
                          </template>
                        </el-table-column>
                        <template slot-scope="scope">
                          <span v-if="item.money">{{
                            scope.row[item.prop] !== ""
                              ? new BigNumber(scope.row[item.prop]).toFormat(2)
                              : ""
                          }}</span>
                          <span v-else-if="item.prop == 'supScore'">{{
                            new BigNumber(scope.row[item.prop]).toFormat(2)
                          }}</span>
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :key="index"
                        :show-overflow-tooltip="true"
                        v-bind="item"
                        v-else-if="!item.labelChild"
                      >
                        <template slot-scope="scope">
                          <el-button
                            v-if="item.type == 'link'"
                            size="mini"
                            type="text"
                            @click="viewBidFile(scope.row)"
                            >查看投标文件</el-button
                          >
                          <span v-else-if="item.money">{{
                            new BigNumber(scope.row[item.prop]).toFormat(8)
                          }}</span>
                          <span v-else-if="item.prop == 'supScore'">{{
                            new BigNumber(scope.row[item.prop]).toFormat(2)
                          }}</span>
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                    </template>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
            <template v-else>
              <template v-for="(listItem, listIndex) in listData">
                <div :key="listIndex">
                  <template v-if="labelType != 'ScoreComplete'">
                    <div class="fr" style="margin-bottom:16px">
                      <template v-if="listItem.hasScore">
                        <el-button
                          style="z-index: 1"
                          type="single-number"
                          plain
                          @click="addOrEditData(listItem, 1)"
                          >编辑</el-button
                        >
                      </template>
                      <template v-else>
                        <el-button
                          style="z-index: 1"
                          type="single-number"
                          plain
                          @click="addOrEditData(listItem, 0)"
                          >新增</el-button
                        >
                      </template>
                    </div>
                    <div class="clearfix"></div>
                  </template>
                  <!--                  <br />-->
                  <el-table :data="listItem.list" border>
                    <template v-for="(item, index) in listItem.columns">
                      <el-table-column
                        :key="index"
                        :show-overflow-tooltip="true"
                        v-bind="item"
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <el-table-column
                          v-for="(child, indexch) in item.labelChild"
                          :key="indexch"
                          align="center"
                          v-bind="child"
                          :show-overflow-tooltip="true"
                        >
                          <template slot="header">
                            <div class="el-tooltip">{{ child.label }}</div>
                          </template>
                        </el-table-column>
                        <template slot-scope="scope">
                          <span v-if="item.money">{{
                            scope.row[item.prop] !== ""
                              ? new BigNumber(scope.row[item.prop]).toFormat(8)
                              : ""
                          }}</span>
                          <span v-else-if="item.prop == 'supScore'">{{
                            new BigNumber(scope.row[item.prop]).toFormat(2)
                          }}</span>
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :key="index"
                        :show-overflow-tooltip="true"
                        v-bind="item"
                        v-else-if="!item.labelChild"
                      >
                        <template slot-scope="scope">
                          <el-button
                            v-if="item.type == 'link'"
                            size="mini"
                            type="text"
                            @click="viewBidFile(scope.row)"
                            >查看投标文件</el-button
                          >
                          <span v-else-if="item.money">{{
                            new BigNumber(scope.row[item.prop]).toFormat(8)
                          }}</span>
                          <span v-else-if="item.prop == 'supScore'">{{
                            new BigNumber(scope.row[item.prop]).toFormat(2)
                          }}</span>
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                    </template>
                  </el-table>
                </div>
              </template>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <template v-if="billStatus == '0'">
      <div class="operate">
        <el-button
          type="text"
          icon="icon-ccui-save"
          v-preventReClick
          @click="dealExpertSupScoreSubmit"
          >提交</el-button
        >
      </div>
    </template>
    <el-dialog
      :visible.sync="dialogVisible"
      title="分包商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supPackQuoteId="formData.supPackQuoteId"
        :supCode="formData.supCode"
        :packId="formData.packId"
      ></supplierBidDetails>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQryExpertScorePackListApi,
  scpQryExpertSupPackQuoteToScoreApi,
  scpQryExpertSupPackQuoteScoreApi,
  scpDealExpertSupScoreSubmitApi,
  scpQryBidEvaProcessStatusApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import bidEvaProcessStatus from "@/app/subSourcingFlow/mixins/getBidEvaProcessStatus.js";

export default {
  name: "subSkiiScoreList",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  data() {
    let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      BigNumber: BigNumber,
      breadcrumbData: {
        titname: "技术评分",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      labelShow: false,
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "score"
          : "ScoreComplete", // 评分中：score 评分完成：ScoreComplete
      billStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      dialogVisible: false,
      listData: [],
      active: "0",
      headers: [],
      formData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件id
      },
      columns: [],
      columnCopy: [
        {
          prop: "id",
          label: "序号",
          width: 55,
          fixed: true
        },
        {
          prop: "supName",
          label: "分包商",
          width: 200,
          fixed: true
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        /* {
          prop: "priceAmount",
          label: "投标金额（" + unit + "）",
          width: 170,
          money: true
        }, */
        {
          prop: "taxAmount",
          label: "税额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          width: 200,
          align: "right",
          money: true
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "查看投标文件",
          label: "投标文件",
          width: 170,
          type: "link"
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术加分项",
          labelChild: [],
          align: "center"
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 110
          // money: true
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 350
        }
      ],
      subPackageFlag: false, // 是否分包 false:不分包
      purchaseType: ""
    };
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      this.columnCopy.splice(4, 1);
      this.columns = this.columnCopy;
    } else {
      this.columns = this.columnCopy;
    }
    this.getData();
  },
  methods: {
    init() {
      this.getData();
      this.reload();
    },
    getData() {
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.labelShow = false;
        this.billStatus = res.data.data.billStatus;
        this.labelType = this.billStatus === "0" ? "score" : "ScoreComplete";
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.labelShow = true;
      });
      scpQryExpertScorePackListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        scoreItem: "0"
      }).then(res => {
        this.subPackageFlag = res.data.data.subPackageFlag;
        let arr = [];
        // subPackageFlag: false 不分包
        if (res.data.data.subPackageFlag) {
          res.data.data.notScorePack.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              arr.push(
                this.qryExpertSupPackQuoteToScore(item.packId, item.packName)
              );
            }
          });
          res.data.data.hasScorePack.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              arr.push(
                this.qryExpertSupPackQuoteScore(item.packId, item.packName)
              );
            }
          });
        } else {
          // 不分包 scoreFlag：true 已评分
          if (res.data.data.scoreFlag) {
            arr.push(this.qryExpertSupPackQuoteScore("", ""));
          }
        }
        Promise.all(arr).then(res => {
          // 通过包件id进行排序
          res.sort(function(a, b) {
            if (a.packId > b.packId) {
              return 1;
            } else if (a.packId < b.packId) {
              return -1;
            } else {
              return 0;
            }
          });
          res.forEach(rItem => {
            rItem.columns = JSON.parse(JSON.stringify(this.columns));
            let labelChild = [];
            let labelChild2 = [];
            rItem.list.forEach((item, index) => {
              item.id = index + 1;
              item.sscScoreBOS.forEach(aItem => {
                aItem.sscScoreItemBOS.forEach(bItem => {
                  item.scoreRule = bItem.scoreRule;
                  let props = "supScore" + bItem.scoreItemId;
                  item[props] =
                    bItem.supScore && new BigNumber(bItem.supScore).toFormat(2);
                  if (aItem.scoreItem === "0") {
                    if (
                      labelChild.filter(item => {
                        return item.prop === "supScore" + bItem.scoreItemId;
                      }).length === 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 120
                      });
                    }
                  }
                  if (aItem.scoreItem === "2") {
                    if (
                      labelChild2.filter(item => {
                        return item.prop === "supScore" + bItem.scoreItemId;
                      }).length === 0
                    ) {
                      labelChild2.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 120
                      });
                    }
                  }
                });
              });
            });
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              if (labelChild.length < 3) {
                delete rItem.columns[7].width;
              }
              rItem.columns[7].labelChild = labelChild;
            } else {
              if (labelChild.length < 3) {
                delete rItem.columns[10].width;
              }
              rItem.columns[8].labelChild = labelChild;
              rItem.columns[9].labelChild = labelChild2;
            }
          });
          this.listData = res;
        });
      });
    },
    // 专家分包商报价待评分列表查询
    qryExpertSupPackQuoteToScore(packId, packName) {
      return new Promise((resolve, reject) => {
        scpQryExpertSupPackQuoteToScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId,
          scoreItem: "0",
          isShowPageLoading: true
        }).then(res => {
          let obj = {
            packId: packId,
            packName: packName,
            hasScore: false, // 是否评分
            list: [],
            headers: []
          };
          if (res.data.data && res.data.data.length > 0) {
            // res.data.data.forEach(item => {
            //   item.sscScoreBOS.forEach(sscScoreBOItem => {
            //     // 将评分项排序保证每条数据对应正确
            //     sscScoreBOItem.sscScoreItemBOS.sort(function(a, b) {
            //       return a.scoreItemId - b.scoreItemId;
            //     });
            //   });
            // });
            // obj.list = res.data.data;
            let flag = true;
            res.data.data[0].sscScoreBOS.forEach(item => {
              if (flag) {
                if (item.scoreItem === "0") {
                  flag = false;
                  obj.headers = Object.assign([], item.sscScoreItemBOS);
                }
              }
            });
          }
          resolve(obj);
        });
      });
    },
    // 专家分包商报价评分列表查询
    qryExpertSupPackQuoteScore(packId, packName) {
      return new Promise((resolve, reject) => {
        scpQryExpertSupPackQuoteScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          scoreItem: "0",
          isShowPageLoading: true
        }).then(res => {
          let obj = {
            packId: packId,
            packName: packName ? packName : "不分包",
            hasScore: true, // 是否评分
            list: [],
            headers: []
          };
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.forEach(aItem => {
              aItem.sscScoreBOS = aItem.sscSupScoreBOS;
              aItem.sscSupScoreBOS.forEach(bItem => {
                bItem.sscScoreItemBOS = bItem.sscSupScoreItemBOS;
                // 将评分项排序保证每条数据对应正确
                bItem.sscScoreItemBOS.sort(function(a, b) {
                  return a.scoreItemId - b.scoreItemId;
                });
              });
            });
            obj.list = res.data.data;
            let flag = true;
            res.data.data[0].sscScoreBOS.forEach(item => {
              if (flag) {
                if (item.scoreItem === "0") {
                  flag = false;
                  obj.headers = Object.assign([], item.sscScoreItemBOS);
                }
              }
            });
          }
          resolve(obj);
        });
      });
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.formData.packId = row.packId;
      this.dialogVisible = true;
    },
    addOrEditData(item, type) {
      // type 0:新增 1：编辑
      this.$router.push({
        name: "scpAddSkiiScore",
        query: {
          type: type,
          packId: item.packId,
          menuKey: this.$router.history.current.query.menuKey,
          evaPurStep: this.$router.history.current.query.evaPurStep
        }
      });
    },
    dealExpertSupScoreSubmit() {
      this.$confirm(
        "您确定要提交吗？评分表提交后，此信息将不允许被编辑修改。",
        "提交评分确认",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "ccui-message-box-custom"
        }
      )
        .then(() => {
          scpQryExpertScorePackListApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            scoreItem: "0",
            isShowLoading: true
          }).then(res => {
            let noScoreFlag = false; // 是否存在正常的未评分包件
            res.data.data.notScorePack.forEach(item => {
              // 看是否流标 packStatus 1正常5流标
              if (item.packStatus == "1") {
                noScoreFlag = true;
              }
            });
            if (noScoreFlag) {
              this.$message({
                message:
                  "您还有评分未完成的包件，请您对每个包件中的分包商评分完毕后，再提交评分结果，谢谢您的配合！！",
                type: "warning",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              return;
            } else {
              scpDealExpertSupScoreSubmitApi({
                schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                  .schemeId,
                joinExpertId: JSON.parse(
                  sessionStorage.getItem("expertSourceData")
                ).joinExpertId,
                scoreType: "0"
              }).then(res => {
                if (res.data.code == "0") {
                  this.init();
                  this.$message({
                    message: "评分表提交成功！",
                    type: "success",
                    duration: 3000,
                    showClose: true,
                    ccuiCustom: true
                  });
                }
              });
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-table td {
  padding: 0 !important;
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
</style>
